// extracted by mini-css-extract-plugin
module.exports = {"entity-header":"entity-header___33A6I"};